import PageComponent from '../base/PageComponent'
export default class AjaxForm extends PageComponent {
    init() {
        this.ready();
    }

    ready() {
        var successMessage = this.element.data('message');
        var form = this.element[0];
        var height = $(".contact-form-holder").offset().top - 90;

        $(form).on('submit', (e) => {
            e.preventDefault();

            this.validate(function(){
                console.log('last');
                //var response = grecaptcha.getResponse();

                $('.spam-error').show();
                $.ajax({
                    type: "POST",
                    url: $(form).attr('action'),
                    data: $(form).serializeArray(),
                    success: function (data) {
                        if (data.Status == 1) {
                            $(form).closest('.contact-form-holder').html(successMessage).addClass('success');
                            console.log('hihi');
                            $("body,html").animate({
                                scrollTop: height
                            });
                        }
                    }
                });
            });

        });
    }



    validate(callback) {
        var form = this.element[0];
        var fields =  $(form).find('.form-control');
        var flag = false;
	var count = fields.length;

      if (grecaptcha === undefined) {
        return false;
      }
      var response = grecaptcha.getResponse();

      if (!response) {
        return false;
      }

        $.each(fields, function(i, val){
            if($(this).attr("name") == 'ContactType' ){
                if($.trim($(this).val()) == 'Please select') {
                    $(this).css('border','2px solid #ffc002');
                    $(form).parent().find('.error-hint').html('Please select the contact type!').show();
                    flag = false;
					return false;
                }else{
                    $('.error-hint').hide();
                    $(this).css('border','2px solid #EC1C24');
                }
            }if($(this).attr("name") == 'Name' ){
                if($.trim($(this).val()) == '') {
                    $(this).css('border','2px solid #ffc002');
                    $(form).parent().find('.error-hint').html('Please input your name!').show();
                    flag = false;
					return false;
                }else{
                    $('.error-hint').hide();
                    $(this).css('border','1px solid #ced4da');
                }
            }else if($(this).attr("name") == 'Phone'){
                if($.trim($.trim($(this).val())) == '') {
                    $(this).css('border','2px solid #ffc002');
                    $(form).parent().find('.error-hint').html('Please input your phone!').show();
                    flag = false;
					return false;
                }else{
                    $('.error-hint').hide();
                    $(this).css('border','1px solid #ced4da');
                }
            }else if($(this).attr("name") == 'Email' ){
                if(!(/(.+)@(.+){2,}\.(.+){2,}/.test($.trim($(this).val())))) {
                    $(this).css('border','2px solid #ffc002');
                    $(form).parent().find('.error-hint').html('Please input valid email!').show();
                    flag = false;
					return false;
                } else {
                    $('.error-hint').hide();
                    $('.error-hint').html(' ');
                    $(this).css('border','1px solid #ced4da');
                }
            }else if($(this).attr('name') == 'Message'){
				if ($.trim($(this).val()) == '') {
                    $(this).css('border','2px solid #ffc002');
                    $(form).parent().find('.error-hint').html('Please input your comment!').show();
                    flag = false;
					return false;
                }else{
                    $('.error-hint').hide().html(' ');
                    $(this).css('border','1px solid #ced4da');
                }
			}else if(count = (i+1)){
				flag = true;
			}

        });


        if(flag == true){
            console.log('before callback');
            callback();
        }


    }
}


// WEBPACK FOOTER //
// ./src/js/components/AjaxForm.js